import React from 'react';
import './PricingPage.css';

const PricingPage: React.FC = () => {
  return (
    <div className="pricing-page-container">
      <div className="pricing-header">
        <h1>Simple, transparent pricing</h1>
        <p>Choose the plan that fits your needs. Try our free trial or unlock all features with our Pro plan.</p>
      </div>
      <div className="pricing-cards-container">
        <div className="pricing-card">
          <h2>Free Trial</h2>
          <p className="price">Free</p>
          <button className="pricing-button trial-button" onClick={() => window.open('https://app.checkifai.nl/', '_blank')}>Start Free Trial</button>
          <ul className="features-list">
            <li><span className="check-icon">✓</span> Full app access for 1 month</li>
            <li><span className="check-icon">✓</span> Limited checklists</li>
            <li><span className="check-icon">✓</span> Basic suggestions</li>
            <li><span className="check-icon">✓</span> Standard support</li>
          </ul>
        </div>
        <div className="pricing-card">
          <h2>Pro (Monthly)</h2>
          <p className="price">10€<span>/user</span></p>
          <button className="pricing-button monthly-button" onClick={() => window.open('https://app.checkifai.nl/', '_blank')}>Get Started (Monthly)</button>
          <ul className="features-list">
            <li><span className="check-icon">✓</span> Unlimited checklists</li>
            <li><span className="check-icon">✓</span> AI-powered suggestions</li>
            <li><span className="check-icon">✓</span> Collaboration tools</li>
            <li><span className="check-icon">✓</span> Priority support</li>
          </ul>
        </div>
        <div className="pricing-card">
          <h2>Pro (Yearly)</h2>
          <p className="price">100€<span>/year</span></p>
          <button className="pricing-button yearly-button" onClick={() => window.open('https://app.checkifai.nl/', '_blank')}>Get Started (Yearly)</button>
          <ul className="features-list">
            <li><span className="check-icon">✓</span> Unlimited checklists</li>
            <li><span className="check-icon">✓</span> AI-powered suggestions</li>
            <li><span className="check-icon">✓</span> Collaboration tools</li>
            <li><span className="check-icon">✓</span> Priority support</li>
          </ul>
        </div>
      </div>
      <p className="no-hidden-fees">No hidden fees. Cancel anytime.</p>
    </div>
  );
};

export default PricingPage;
